import { Button, Modal } from 'flowbite-react';
import React from 'react';
interface Props {
	isOpen?: boolean;
	onClose?: () => void;
}
const TermsOfPlacementDrivesModal = ({ isOpen, onClose }: Props) => {
	return (
		<div className="">
			{' '}
			<Modal show={isOpen} onClose={onClose} size="3xl">
				<Modal.Header className="border-b-0 flex justify-items-end">Placement Drive Terms</Modal.Header>
				<Modal.Body className="!p-0">
					<div className="px-[20px]">
						<p className="font-inter text-[#28293D] text-[14px] font-[500] leading-[20pxP]">
							<strong>Code of conduct:</strong>
							<br />
							<ol className="list-decimal pl-[20px]">
								<li className="list-decimal">
									Commitment to Participation: By registering for the placement drive, companies agree to participate in
									the event on the specified date(s).Any withdrawal must be communicated at least 15 days in advance,
									failing which may result in restrictions on future participation.
								</li>
								<li>
									Honouring Offers Made: Companies must honor all job offers made to students during the placement
									drive. Any revocation of offers after issuance will lead to disqualification from future events.
								</li>
								<li>
									Transparent Communication: Companies are required to provide clear and honest information about the
									roles, compensation, and work environment during interactions with students. Any misleading
									information can lead to exclusion from future drives.
								</li>
								<li>
									On-site Representative Attendance: A designated company representative must be physically present
									throughout the duration of the placement drive. Absence without prior notice will be taken seriously
									and may affect future collaborations.
								</li>
								<li>
									Respect for Timelines and Procedures: Companies are expected to adhere to the event schedule and
									follow all placement procedures laid out by the organizers to ensure a smooth and fair process for all
									participants.
								</li>
							</ol>
						</p>
					</div>
				</Modal.Body>
				<Modal.Footer className="border-t-0 flex justify-center">
					<Button onClick={onClose} className="w-full max-w-[160px] mx-auto" color="purplePlaced">
						I accept
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
};

export default TermsOfPlacementDrivesModal;
